import { getStateCodeFromName } from '@/pages/AuctionsNearMe/helpers/geoAreaToUrlParams';

/**
 * Fast, pre-fetch rejection for a city/state pair that cannot be a real location: an
 * unrecognized state/province segment, or a duplicated city === state segment (e.g.
 * "/bc/bc/", "/ny/quogue-ny/"). Mirrors the malformed-location check `auctionsNearMePageData.ts`
 * runs before calling `near-me-v2`, so both the SSR loader and any link-rendering surface agree
 * on what counts as a plausible Auctions Near Me location.
 */
export const isPlausibleLocation = (city: string, state: string): boolean => {
    if (!city || !state) {
        return false;
    }

    const stateCode = getStateCodeFromName(state);
    const citySegment = city.toLowerCase();

    return Boolean(stateCode) && stateCode !== citySegment && state.toLowerCase() !== citySegment;
};
